/**
 * Internal helper for the `POST api/{tasks|projects|meetings|bookings}/by-ids` calls (Events hub
 * Stage 2). Not exported from the barrel.
 *
 * De-duplicates the ids, drops anything that is not a positive whole number and sends them in
 * batches of at most WORK_ITEM_BY_IDS_MAX (the server's limit), one batch after another.
 */
import { WORK_ITEM_BY_IDS_MAX } from '../../models/common/WorkItemSummary';
/** Positive whole ids, de-duplicated, in their first-seen order. */
export function cleanWorkItemIds(ids) {
    const out = [];
    const seen = new Set();
    ids.forEach((raw) => {
        const n = typeof raw === 'number' ? raw : Number(raw);
        if (!Number.isSafeInteger(n) || n <= 0 || seen.has(n))
            return;
        seen.add(n);
        out.push(n);
    });
    return out;
}
/** POST each batch to `url` and join the summaries. Throws when a batch fails. */
export async function fetchWorkItemsByIds(http, url, ids, what) {
    const clean = cleanWorkItemIds(ids);
    if (clean.length === 0)
        return [];
    const out = [];
    for (let i = 0; i < clean.length; i += WORK_ITEM_BY_IDS_MAX) {
        const batch = clean.slice(i, i + WORK_ITEM_BY_IDS_MAX);
        const res = await http.post(url, { ids: batch });
        if (res.success === false)
            throw new Error(res.message || `Could not load the ${what}`);
        out.push(...(res.data ?? []));
    }
    return out;
}
//# sourceMappingURL=workItemsByIds.js.map